import api from '../../apiConfig/apiConfig'
import { Get, Post, Put, Delete, Patch } from '../base/baseAjax'
export default {
  addClue(param) {
    return Post({
      url: api.clue.addClue,
      bodyParam: param,
    })
  },
  clueList(param) {
    return Post({
      url: api.clue.clueList,
      bodyParam: param,
    })
  },
  distributionClue(param) {
    return Post({
      url: api.clue.distributionClue,
      bodyParam: param,
    })
  },
  focus(param) {
    return Get({
      url: api.clue.focus,
      PathParam: param,
    })
  },
  catchClue(param) {
    return Get({
      url: api.clue.catchClue,
      PathParam: param,
    })
  },
  publicClueList(param) {
    return Post({
      url: api.clue.publicClueList,
      bodyParam: param,
    })
  },
  clueDetails(param) {
    return Get({
      url: api.clue.clueDetails,
      PathParam: param,
    })
  },
  toCustomer(param) {
    return Post({
      url: api.clue.toCustomer,
      bodyParam: param,
    })
  },
  movePublic(param) {
    return Post({
      url: api.clue.movePublic,
      bodyParam: param,
    })
  },
  transferClue(param) {
    return Post({
      url: api.clue.transferClue,
      bodyParam: param,
    })
  },
  dynamicList(param) {
    return Get({
      url: api.clue.dynamicList,
      PathParam: param,
    })
  },
  inquriyreply(param) {
    return Post({
      url: api.clue.inquriyreply,
      bodyParam: param,
    })
  },
  // 获取转送人信息
  getpassoninfo(param) {
    return Post({
      url: api.clue.getpassoninfo,
      bodyParam: param,
    })
  },
  inquirytransmit(param) {
    return Post({
      url: api.clue.inquirytransmit,
      bodyParam: param,
    })
  },
  crmClueDetails(param) {
    return Get({
      url: api.clue.crmClueDetails,
      PathParam: param,
    })
  },
  updateCompanyInfo(param) {
    return Post({
      url: api.clue.updateCompanyInfo,
      bodyParam: param,
    })
  },
  historyList(param) {
    return Get({
      url: api.clue.historyList,
      PathParam: param,
    })
  },
  inquiryRead(param) {
    return Post({
      url: api.clue.inquiryRead,
      bodyParam: param,
    })
  },
  deleteClue(param) {
    return Post({
      url: api.clue.deleteClue,
      bodyParam: param,
    })
  },
  downloadList(param) {
    return Post({
      url: api.clue.downloadList,
      bodyParam: param,
      config: {
        timeout: 60000,
        responseType: 'blob',
      },
    })
  },
  companyInfo(param) {
    return Get({
      url: api.clue.companyInfo,
      PathParam: param,
    })
  },
  followList(param) {
    return Get({
      url: api.clue.followList,
      PathParam: param,
    })
  },
  inquiryConvert(param) {
    return Post({
      url: api.clue.inquiryConvert,
      bodyParam: param,
    })
  },
  addDynamic(param) {
    return Post({
      url: api.clue.addDynamic,
      bodyParam: param,
    })
  },
}
